<template lang="pug">
#offline-users
  main.relative.text-gray-700
    section.relative.shadow-md.rounded.overflow-hidden
      .absolute.inset-0.bg-white.opacity-50

      .relative
        .flex
          button.text-xl.uppercase.tracking-wider.p-4.flex-grow.text-left(class="w-1/2" :class="selectedTab === 'create' ? 'text-gray-700 bg-white' : 'text-gray-500'" @click="selectedTab = 'create'") Create Offline
          button.text-xl.uppercase.tracking-wider.p-4.flex-grow.text-right(class="w-1/2" :class="selectedTab === 'test' ? 'text-gray-700 bg-white' : 'text-gray-500'" @click="selectedTab = 'test'") Test Offline

        form.p-4.bg-white(@submit.prevent="submit" v-if="selectedTab === 'create'")
          .mb-4.rounded.shadow
            .relative.h-12.overflow-hidden
              .absolute.inset-0.pl-16
                flat-pickr.h-12.w-full.px-4(v-model="end")
              label.text-xs.uppercase.tracking-wider.absolute.inset-0.w-16.flex.items-center.justify-center.bg-gray-200 End

            .relative.h-12.overflow-hidden.border-t.border-gray-300
              .absolute.inset-0.pl-16
                input.h-12.w-full.px-4(v-model="reason")
              label.text-xs.uppercase.tracking-wider.absolute.inset-0.w-16.flex.items-center.justify-center.bg-gray-200 For

          .mb-4.text-red-500.text-sm(v-if="error") {{ error }}

          button.rounded.shadow.w-full.h-12.bg-teal-500.text-white(class="hover:bg-teal-600" :disabled="isSubmitting") Create

        form.p-4.bg-white(@submit.prevent="test" v-if="selectedTab === 'test'")
          .mb-4.rounded.shadow
            .relative.h-12.overflow-hidden
              .absolute.inset-0.pl-24
                input.h-12.w-full.px-4(placeholder="Username" name="username" v-model="username")
              label.text-xs.uppercase.tracking-wider.absolute.inset-0.w-24.flex.items-center.justify-center.bg-gray-200 Username

            .relative.h-12.overflow-hidden.border-t.border-gray-300
              .absolute.inset-0.pl-24
                input.h-12.w-full.px-4(placeholder="Password" type="password" name="password" v-model="password")
              label.text-xs.uppercase.tracking-wider.absolute.inset-0.w-24.flex.items-center.justify-center.bg-gray-200 Password

          .mb-4.text-red-500.text-sm(v-if="testError") {{ testError }}

          button.rounded.shadow.w-full.h-12.bg-teal-500.text-white(class="hover:bg-teal-600" :disabled="isTesting") Test

    section.relative.mt-4.shadow-md.rounded.overflow-hidden
      .absolute.inset-0.bg-white.opacity-75

      .relative
        .p-4(class="md:flex")
          h2.text-xl.uppercase.tracking-wider.flex-grow Offline Users
          .w-full.relative.mt-2(class="md:mt-0 md:w-64")
            input.w-full.h-10.pl-10.bg-white.rounded.shadow(v-model.trim="search")
            .h-10.w-10.absolute.top-0.left-0.flex.items-center.justify-center
              i.fa.fa-search

        table.w-full.hidden.bg-white(class="lg:table")
          thead
            tr.uppercase.tracking-wider.text-xs.bg-gray-300
              th.font-light.p-2.border-gray-500.border-r.w-40 Username
              th.font-light.p-2.border-gray-500.border-r.w-40 Password
              th.font-light.p-2.border-gray-500.border-r.w-32 End
              th.font-light.p-2.border-gray-500.border-r.w-32 For
              th.font-light.p-2.border-gray-500.border-r Created
              th.font-light.w-10

          tbody
            tr.border-gray-500.border-t(class="hover:bg-gray-200" v-for="user in filteredUsers" :key="user.username")
              td.p-2.border-gray-500.border-r {{ user.username }}
              td.p-2.border-gray-500.border-r {{ user.password }}
              td.p-2.border-gray-500.border-r {{ user.end }}
              td.p-2.border-gray-500.border-r {{ user.for }}
              td.p-2.border-gray-500.border-r.text-center {{ user.created }}
              td.w-8.p-1.text-center
                button.text-red-500.w-8.h-8.rounded(class="hover:bg-red-500 hover:text-white" @click="remove(user)")
                  i.fa.fa-times

        .px-4.pb-4(class="lg:hidden")
          .p-4.mb-4.relative.shadow.rounded.bg-white(v-for="user in filteredUsers" :key="user.username")
            .relative
              .mb-4
                label.mb-1.block.text-xs.uppercase.tracking-wider.text-gray-500 Username
                p.px-2 {{ user.username }}
              .mb-4
                label.mb-1.block.text-xs.uppercase.tracking-wider.text-gray-500 Password
                p.px-2 {{ user.password }}
              .mb-4
                label.mb-1.block.text-xs.uppercase.tracking-wider.text-gray-500 End
                p.px-2 {{ user.end }}
              .mb-4
                label.mb-1.block.text-xs.uppercase.tracking-wider.text-gray-500 For
                p.px-2 {{ user.for }}
              div
                label.mb-1.block.text-xs.uppercase.tracking-wider.text-gray-500 Created
                p.px-2 {{ user.created }}

            .absolute.top-0.right-0
              button.text-red-500.w-8.h-8.rounded(class="hover:bg-red-500 hover:text-white" @click="remove(user)")
                i.fa.fa-times
</template>

<script>
import axios from 'axios'
import dayjs from 'dayjs'
import { createComponent, ref, computed } from '@vue/composition-api'
import flatPickr from 'vue-flatpickr-component'

export default createComponent({
  components: {
    flatPickr
  },
  setup (props, context) {
    const users = ref([])

    function loadUsers () {
      return axios.get('/api/offline/list')
        .then(({ data: response }) => {
          users.value = response.map(user => {
            user.created = dayjs(user.created).format('YYYY-MM-DD HH:mm')

            return user
          })
        })
    }

    loadUsers()

    const search = ref('')

    const filteredUsers = computed(() => {
      if (search.value === '') {
        return users.value
      }

      const pattern = new RegExp(search.value, 'i')

      return users.value.filter(user => {
        return pattern.test(user.for) || pattern.test(user.username) || pattern.test(user.password)
      })
    })

    const isSubmitting = ref(false)
    const end = ref(dayjs().add(3, 'month').format('YYYY-MM-DD'))
    const reason = ref('')
    const error = ref('')

    async function submit () {
      if (!end.value || !reason.value) {
        error.value = 'Missing required value.'
        return
      }

      if (isSubmitting.value) {
        return
      }

      error.value = ''
      isSubmitting.value = true

      try {
        const { data: user } = await axios.post('/api/offline/create', {
          end: end.value,
          for: reason.value
        })

        user.created = dayjs(user.created).format('YYYY-MM-DD HH:mm')

        isSubmitting.value = false

        reason.value = ''

        users.value.unshift(user)
      } catch (err) {
        isSubmitting.value = false

        error.value = error.value = err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Invalid data.'
      }
    }

    const isRemoving = ref(false)

    async function remove (user) {
      if (isRemoving.value) {
        return
      }

      try {
        await context.root.$confirm(`Delete user: ${user.username}`)
      } catch {
        return
      }

      isRemoving.value = true

      await axios.delete(`/api/offline/${user.username}`)

      isRemoving.value = false

      const itemIndex = users.value.findIndex(item => item.username === user.username)

      if (itemIndex >= 0) {
        users.value.splice(itemIndex, 1)
      }
    }

    const selectedTab = ref('create')
    const username = ref('')
    const password = ref('')
    const isTesting = ref(false)
    const testError = ref('')

    async function test () {
      if (!username.value || !password.value) {
        return
      }

      if (isTesting.value) {
        return
      }

      testError.value = ''
      isTesting.value = true

      try {
        await axios.post('/api/offline/test', {
          username: username.value,
          password: password.value
        })

        isTesting.value = false

        context.root.$alert('Valid credentials!', '', 'success')
      } catch (err) {
        isTesting.value = false

        testError.value = testError.value = err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Invalid credentials.'
      }
    }

    return {
      users,
      search,
      filteredUsers,
      isSubmitting,
      end,
      reason,
      error,
      submit,
      remove,
      selectedTab,
      username,
      password,
      isTesting,
      testError,
      test
    }
  }
})
</script>
